/**
 * Workflow Publishing Validation - Orchestrator
 *
 * Sequences all domain validators before publishing.
 * Each validator returns null (pass) or { message } (fail).
 */

import {
  validateWorkflowStructure,
  validateNodeConnectivity,
  validateStartNodeConnections,
} from './structureValidation';
import {
  validateStageRequirements,
  validateNodeConfiguration,
} from './stageValidation';
import {
  validateSubmissionNodeConnections,
  validateReviewNodeConnections,
  validateConsecutiveSubmissions,
} from './connectionValidation';
import {
  validateFormReviewCoverage,
  validateReviewFormOrder,
  validateAssessmentReviewFormOrder,
  validateSingleAssessmentReviewStage,
} from './coverageValidation';
import { validateApprovalNodes } from './approvalValidation';

const validatePublishing = (workflowData) => {
  const errors = {};
  const { nodes, edges } = workflowData || {};

  const structureError = validateWorkflowStructure(workflowData);
  if (structureError) {
    errors.message = structureError.message;
    return errors;
  }

  const connectivityError = validateNodeConnectivity(nodes, edges);
  if (connectivityError) {
    errors.message = connectivityError.message;
    return errors;
  }

  const stageError = validateStageRequirements(nodes, edges);
  if (stageError) {
    errors.message = stageError.message;
    return errors;
  }

  const configError = validateNodeConfiguration(nodes);
  if (configError) {
    errors.message = configError.message;
    return errors;
  }

  const consecutiveError = validateConsecutiveSubmissions(nodes, edges);
  if (consecutiveError) {
    errors.message = consecutiveError.message;
    return errors;
  }

  const coverageError = validateFormReviewCoverage(nodes);
  if (coverageError) {
    errors.message = coverageError.message;
    return errors;
  }

  const orderError = validateReviewFormOrder(nodes, edges);
  if (orderError) {
    errors.message = orderError.message;
    return errors;
  }

  const assessmentReviewOrderError = validateAssessmentReviewFormOrder(
    nodes,
    edges
  );
  if (assessmentReviewOrderError) {
    errors.message = assessmentReviewOrderError.message;
    return errors;
  }

  const approvalError = validateApprovalNodes(nodes, edges);
  if (approvalError) {
    errors.message = approvalError.message;
    return errors;
  }

  const submissionConnectionsError = validateSubmissionNodeConnections(
    nodes,
    edges
  );
  if (submissionConnectionsError) {
    errors.message = submissionConnectionsError.message;
    return errors;
  }

  const reviewConnectionsError = validateReviewNodeConnections(nodes, edges);
  if (reviewConnectionsError) {
    errors.message = reviewConnectionsError.message;
    return errors;
  }

  const singleAssessmentError = validateSingleAssessmentReviewStage(nodes);
  if (singleAssessmentError) {
    errors.message = singleAssessmentError.message;
    return errors;
  }

  const startNodeError = validateStartNodeConnections(nodes, edges);
  if (startNodeError) {
    errors.message = startNodeError.message;
    return errors;
  }

  return null;
};

export default validatePublishing;
